import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import MainList from './MainList/MainList';
import Record from './RecordDetail';
import { GlobalStyle } from './globalstyles';

const App: React.FC = () => {
  return (
    <>
      <GlobalStyle />
      <Router basename="/">
        <Routes>
          <Route path="/" element={<MainList />} />
          <Route path="/record/:id" element={<Record />} />
        </Routes>
      </Router>
    </>
  );
};

export default App;
